//
//
//
//
//
//
//
//
//
//

import { getNonSessionIconPath } from './scheduleResultGrouping.js';

export default {
  name: 'SessionTypeIcon',

  props: {
    sessionType: {
      type: String,
      required: true,
    },
  },

  computed: {
    iconSrc() {
      return getNonSessionIconPath(this.sessionType);
    },
  },
};
